export enum MergeCompanyStatus {
  MergingOrders = 1,
  DeactivatingCompanies = 2,
  MergeOrdersAndCompanySuccessful = 3,
  MergingOrdersFailed = 4,
  MergingCompanyFailed = 5
}
